import React, { useEffect, useState } from "react";
import FormComponent from "../../../../components/gernerateForm/FormComponent";
import formGenerateRegisterInfo from "./formGenerateRegisterInfo.data";
import { StudentApi } from "../../../../api/student/student.api";

const RegisterInformation = ({
  student_id,
  id_student_register_payment,
  isCanEdit,
  setPorpBodyData,
}: {
  student_id: number;
  id_student_register_payment: number;
  isCanEdit: boolean;
  setPorpBodyData: (value: any) => void;
}) => {
  const [inputData, setInputData] = useState<any>({
    register: {
      dregree: "",
      faculty: "",
      education_year: "",
      current_email: "",
      year_study: "",
      data_commencement_studie: "",
      student_id_number: "",
      student_email: "",
    },
  });

  useEffect(() => {
    setPorpBodyData(inputData);
  }, [inputData]);

  const getRegisterInfo = async (
    student_id: number,
    id_student_register_payment: number
  ) => {
    const res = await StudentApi.fetchGetResigterInfo(
      student_id,
      id_student_register_payment
    );
    const data = res.data;
    if (data.status < 300) {
      setInputData({
        register: {
          dregree:
            data.data?.student_register_payment?.course_of_study?.faculty
              ?.id_degree ?? 0,
          faculty:
            data.data?.student_register_payment?.course_of_study?.id_faculty ??
            0,
          education_year: data.data?.term ?? "",
          current_email: "",
          year_study: data.data?.year ?? "",
          data_commencement_studie: "",
          student_id_number: data.data?.student?.student_no ?? "",
          student_email: data.data?.student?.student_email ?? "",
        },
      });
    } else {
      setInputData({});
    }
  };

  useEffect(() => {
    if (student_id && id_student_register_payment) {
      getRegisterInfo(student_id, id_student_register_payment);
    }
  }, [student_id, id_student_register_payment]);

  return (
    <>
      <FormComponent
        formGenerate={formGenerateRegisterInfo}
        inputValue={inputData}
        setInputValue={setInputData}
        handleCheckValid={false}
        isCanEdit={isCanEdit}
        permission={"admin"}
      />
    </>
  );
};

export default RegisterInformation;
